module.exports = __webpack_public_path__ + "static/media/idRef.6191dc8a.png";